import axios from 'axios';
import qs from 'qs';

import store from '@state/store'

class AxiosHelper {
	constructor() {
		this.instance = axios.create({
			baseURL : process.env.VUE_APP_BACKEND,
			headers: {
				
				// Accept: 'application/json, text/javascript, */*; q=0.01',
				// 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				// 'X-Requested-With': 'XMLHttpRequest'
			},
			paramsSerializer: function (params) {
				return qs.stringify(params, {arrayFormat: 'brackets'})
			},
		});

		AxiosHelper.get = AxiosHelper.get.bind(this);
		AxiosHelper.post = AxiosHelper.post.bind(this);
		AxiosHelper.put = AxiosHelper.put.bind(this);
		AxiosHelper.patch = AxiosHelper.patch.bind(this);
		AxiosHelper.delete = AxiosHelper.delete.bind(this);
		AxiosHelper.baseUrl = AxiosHelper.baseUrl.bind(this);
		
		// axios.defaults.baseURL = 'http://192.168.0.31:3001';
		// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
		// Content-Type: application/x-www-form-urlencoded; 
		this.axiosCallCount = 0;
		this.instance.interceptors.request.use((config) => {
			store.dispatch('simple/showProgress');
			this.axiosCallCount++;
		
			// const user = getLoggedInUser();
			// if(user) {
			// 	config.headers.Authorization = `${user.token}`
			// }

			return config;
		}, (error) => {
			this.axiosCallCount--;
			store.dispatch('simple/hideProgress');

			return Promise.reject(error);
		});

		this.instance.interceptors.response.use((response) => {
			this.axiosCallCount--;
			if(!this.axiosCallCount) {
				store.dispatch('simple/hideProgress');
			}

			if(response.data.isError) {
				store.dispatch('simple/pushMessage', response.data.msg, 'danger');
				return Promise.reject(response.data.msg);
			}

			return response.data;
		}, (error) => {
			this.axiosCallCount--;
			if(!this.axiosCallCount) {
				store.dispatch('simple/hideProgress');
			}

			store.dispatch('simple/pushMessage', error.toString(), 'danger');
			return Promise.reject(error);
		});

	}

	static get(url, config) {
		return this.instance.get(url, config);
	}
	static post(url, data, config) {
		return this.instance.post(url, data, config);
	}
	static put(url, data, config) {
		return this.instance.put(url, data, config);
	}
	static patch(url, data, config) {
		return this.instance.patch(url, data, config);
	}
	static delete(url, config) {
		return this.instance.delete(url, config);
	}

// axios.head(url[, config])
// axios.options(url[, config])
// axios.put(url[, data[, config]])

	static baseUrl() {
		return `${this.instance.defaults.baseURL}`;
	}
}


function combine(def, usr) {
	function isEnd(v, k) {
		return ((v instanceof Function) || !(v instanceof Object));
	}
	function _(dst, def, usr) {
		for(var prop in def) {
			if(prop === 0) {
				return;
			}
			if(isEnd(def[prop], prop)) {
				dst[prop] = (usr[prop] || usr[prop] === 0) ? usr[prop] : def[prop];
			}
			else {
				dst[prop] = {};
				_(dst[prop], def[prop], usr[prop]);
			}
		}
	}
	var dst = {};
	_(dst, def, usr);
	return dst;
};

const speech = (function() {
	var voices = [];

	if(window.speechSynthesis) {
		voices = window.speechSynthesis.getVoices();
	}

	return function(param, cb) {
		if(!window.speechSynthesis) {
			alert("음성 재생을 지원하지 않는 브라우저입니다. 크롬, 파이어폭스 등의 최신 브라우저를 이용하세요");
			return;
		}

		window.speechSynthesis.cancel();	// 무조건 캔슬한다.

		if(window.speechSynthesis.speaking) {
			console.error('speechSynthesis.speaking');
			return;
		}

		var defaultOption = {
			text : '', 
			lang : 'KR',
			rate : 1
		};
		
		var op = combine(defaultOption, param);

		if(!op.text) {
			// eslint-disable-next-line
			cb('no word');
			return;
		}

		const utterThis = new SpeechSynthesisUtterance(op.text);
		utterThis.onend = function (event) {
			cb();
		};
		utterThis.onboundary = function(event) {
			console.log(event.name + ' boundary reached after ' + event.elapsedTime + ' milliseconds.');
		};
		utterThis.onmark = function(event) {
			console.log('A mark was reached: ' + event.name);
		};
		utterThis.onpause = function(event) {
			console.log('Speech paused after ' + event.elapsedTime + ' milliseconds.');
		};
		utterThis.onresume = function(event) {
			console.log('Speech resumed after ' + event.elapsedTime + ' milliseconds.');
		};
		utterThis.onstart = function(event) {
			// console.log('We have started uttering this speech: ' + event.utterance.text);
		};
		utterThis.onerror = function(event) {
			alert(event.error);
			cb(event);
		};

		
		var voiceFound = false;
		if(window.speechSynthesis && voices.length === 0) {
			voices = window.speechSynthesis.getVoices();
		}

		for(var i = 0; i < voices.length ; i++) {
			if(voices[i].lang.indexOf(op.lang) >= 0 || voices[i].lang.indexOf(op.lang.replaceAll('-', '_')) >= 0) {
				utterThis.voice = voices[i];
				voiceFound = true;
			}
		}

		if(!voiceFound) {
			alert(op.lang + ' voice not found');
			return;
		}
		var langSet = {
			KR : 'ko-KR',
			CN : 'zh-CN'
		};

		utterThis.lang = langSet[op.lang];
		utterThis.pitch = 1;
		utterThis.rate = op.rate;	// 속도
		window.speechSynthesis.speak(utterThis);
	};

})();



export {
	AxiosHelper,
	combine,
	speech,
}
